export const loadScript = async (url: string, id: string, type: string = 'text/javascript'): Promise<HTMLScriptElement | null> => {
	if (document.getElementById(id) as HTMLScriptElement) {
		return Promise.resolve(null);
	}

	return new Promise<HTMLScriptElement>(((resolve) => {
		const script: HTMLScriptElement = document.createElement('script');
		script.type = type;
		script.src = url;
		script.id = id;
		script.addEventListener('load', () => resolve(script));
		document.body.appendChild(script);
	}));
};



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/ultils.ts